/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { authorModelSchema } from "./authorModelSchema.ts";
import { z } from "zod";

export const authorModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => authorModelSchema))
    })